"use client";

import { SparklesIcon } from "@heroicons/react/24/outline";
import { useUser } from "@clerk/nextjs";

import { Diligence as DiligenceBase } from "@/app/_components/diligence/diligence";
import { CardEmpty } from "@/app/_components/card-empty";
import { RequiredBuyPremiumButton } from "@/app/_components/required/buy-premium-button";

import { getUserPlanByMetadata } from "@/helper/user/client";

import type { AnalyzeFilter } from "@/types";

interface DiligenceProps extends AnalyzeFilter {
  emptyElement?: React.ReactNode;
}

export const Diligence = ({
  id,
  field = "numero_do_leilao",
  emptyElement,
}: DiligenceProps) => {
  const { user } = useUser();
  const { hasPaidPlan } = getUserPlanByMetadata(user?.publicMetadata);

  if (!hasPaidPlan) {
    return (
      <CardEmpty
        title="Diligência prévia do imóvel"
        description="Examine todas as informações do imóvel e antigo proprietário para garantir que ele está livre de pendências judiciais e fiscais."
        icon={<SparklesIcon className="h-8 w-8 text-primary" />}
      >
        <RequiredBuyPremiumButton />
      </CardEmpty>
    );
  }

  return <DiligenceBase id={id} field={field} emptyElement={emptyElement} />;
};
